import React from 'react';

import { Box, Container, Heading, Text, useMediaQuery } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { MediaQueryAmountsEnum } from '@/enum/mediaQueryAmounts.enum';

/**
 * Component for About us section in Home page
 * @component
 * @example
 * <AboutUsSection />.
 */
const AboutUsSection: React.FC = () => {
  const { t } = useTranslation();
  const [isMobile] = useMediaQuery(MediaQueryAmountsEnum.isMobile);

  return (
    <Container
      id='about-us'
      maxW='1440px'
      sx={{
        display: 'flex',
        p: {
          base: '115px 40px 60px',
          md: '150px 40px 60px',
          lg: '160px 40px 120px',
        },
        color: 'app.black',
        alignItems: { base: 'center', lg: 'center' },
        flexDirection: 'column',
      }}
    >
      <Box>
        <Heading
          alignContent='center'
          as='h1'
          color='app.pink'
          size={isMobile ? '2xl' : '3xl'}
        >
          {t('main.aboutUs.title')}
        </Heading>

        <Box
          background='app.pink'
          h='4px'
          m='20px auto 25px'
          w={{ base: '50px', md: '66px' }}
        />
      </Box>

      {!isMobile ? (
        <Text
          align={{ base: 'left', lg: 'center' }}
          fontSize={{ base: '16px', lg: '20px' }}
          m='20px 0'
          maxW='710px'
          w='100%'
        >
          {t('main.aboutUs.textDesktop')}
        </Text>
      ) : (
        <Box
          fontSize={{ base: '16px', lg: '20px' }}
          m='38px 0'
          textAlign={{ base: 'center', lg: 'center' }}
        >
          <Text pb='20px'>{t('main.aboutUs.textDesktop')}</Text>
        </Box>
      )}
    </Container>
  );
};

export default AboutUsSection;
